import React from 'react';
import { Grid } from '@material-ui/core';
import { CameraAltOutlined } from '@material-ui/icons';
import {
  CustomizedButton,
  CustomizedDialog,
  CustomizedTypography
} from '@components/Customized';
import useStyles from './styles';

interface Props {
  open: boolean;
  onClose: () => void;
  onUploadPicture: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onDelete: () => void;
}

export default (props: Props) => {
  const classes = useStyles();
  return (
    <CustomizedDialog
      open={props.open}
      onClose={props.onClose}
      icon={<CameraAltOutlined />}
      title="프로필 사진 설정"
      color="primary"
      maxWidth={476}
    >
      <Grid container>
        <CustomizedTypography classes={{ root: classes.title }}>
          기존에 존재하는 이미지가 있습니다. 변경하시겠습니까?
        </CustomizedTypography>
      </Grid>

      <Grid
        container
        wrap="nowrap"
        justifyContent="space-between"
        className={classes.btnGroup}
      >
        <CustomizedButton
          color="secondary"
          variant="contained"
          fullWidth
          size="medium"
          classes={{ root: classes.button, containedSecondary: 'secondary' }}
          onClick={props.onDelete}
        >
          삭제하기
        </CustomizedButton>
        <CustomizedButton
          color="primary"
          variant="contained"
          fullWidth
          size="medium"
          classes={{ root: classes.button }}
          onClick={props.onUploadPicture}
        >
          새 이미지 업로드
        </CustomizedButton>
      </Grid>
    </CustomizedDialog>
  );
};
